// extracted by mini-css-extract-plugin
export default {"cartItemQuantityInput":"cartItemQuantityInput__ZjI3N"};